import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var textButton = createRuntimeFn({defaultClassName:'fx_e395032e_gpw9nu1',variantClassNames:{accentColor:{true:'fx_e395032e_gpw9nu2',false:'fx_e395032e_gpw9nu3'},disabled:{true:'fx_e395032e_gpw9nu4',false:'fx_e395032e_gpw9nu5'},gradientText:{true:'fx_e395032e_gpw9nu6',false:'fx_e395032e_gpw9nu7'}},defaultVariants:{},compoundVariants:[]});
var textButtonColor = 'var(--fx_e395032e_gpw9nu0)';
var textButtonFocusVisible = 'fx_e395032e_gpw9nu8';

export { textButton, textButtonColor, textButtonFocusVisible };
//# sourceMappingURL=textButton.vanilla.mjs.map
